import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import * as moment from 'moment';

@Directive( {
  selector: '[appTimeFilter]'
} )
export class TimeDirective {

  @Input( 'appTimeFilter' ) input;

  constructor ( private el: ElementRef ) {
    this.el.nativeElement.maxLength = 5;
  }

  @HostListener( 'input', ['$event'] )
  InputDate ( event ) {
    switch ( event.inputType ) {
      case 'insertText': {
        if ( event.target.value.match( /^\d{2}$/ ) !== null ) {
          if ( event.target.value.match( /^(0[0-9])|(1[0-9])|(2[0-3])$/ ) !== null ) {
            event.target.value += '.';
          } else {
            event.target.value = moment().hours() + '.';
          }
        } else if ( event.target.value.match( /^\d[\s-.;\/]$/ ) !== null ) {
          event.target.value = '0' + event.target.value[0] + '.';
        } else if ( event.target.value.match( /^\d{2}\.\d\.$/ ) !== null ) {
          let a = event.target.value.split( '.' );
          event.target.value = a[0] + '.0' + parseInt( a[1] ) + '.';
        } else if ( event.target.value.match( /^\d{2}\.\d{2}$/ ) !== null ) {
          if ( event.target.value.match( /^((0[0-9])|(1[0-9])|(2[0-3]))\.((0\d)|(1\d)|(2\d)|(3\d)|(4\d)|(5\d))$/ ) !== null ) {
          } else {
            event.target.value = moment().hours() + '.' + moment().minutes();
          }
        } else if ( event.target.value.match( /[a-zA-Zа-я;\s]+/gi ) ) {
          event.target.value = event.target.value.replace( /[a-zA-Zа-я;\s]/, '' );
        } else if ( event.target.value.match( /[\s-,/;]/ ) ) {
          event.target.value = event.target.value.replace( /[\s-/,]/, '.' );
        } else if ( event.target.value.match( /\.+/ ) ) {
          event.target.value = event.target.value.replace( /\.+/, '.' );
        }
        break;
      }
      case 'deleteContentBackward': {
        console.log( event.target.value );
        if ( event.target.value.match( /^\d{2}.\d{2}\.$/ ) !== null ) {
          event.target.value = event.target.value.replace( /\d\.$/, '' );
        } else if ( event.target.value.match( /^\d{2}\.\d{2}$/ ) !== null ) {
          event.target.value = event.target.value.replace( /\d$/, '' );
        } else if ( event.target.value.match( /^\d{2}$/ ) !== null ) {
          event.target.value = event.target.value.replace( /\d$/, '' );
        }
        break;
      }
    }
  }

  @HostListener( 'paste', ['$event'] )
  InputPaste ( event ) {
    event.target.value = moment().format( 'DD.MM.YYYY' );
  }

  @HostListener( 'focus', ['$event'] )
  FocusDate ( event ) {
    console.log( event );
    console.log( this.el.nativeElement.value );
  }

  @HostListener( 'blur', ['$event'] )
  BlureDate ( event ) {
    if ( event.target.value.match( /^\d$/ ) ) {
      event.target.value = 0 + event.target.value + '.' + moment().minutes();
    } else if ( event.target.value.match( /^\d{2}\.$/ ) !== null ) {
      if ( event.target.value.match( /^(0[0-9])|(1[0-9])|(2[0-3])\.$/ ) !== null ) {
        event.target.value += moment().minutes();
      } else {
        event.target.value = moment().format( 'HH.mm' );
      }
    } else if ( event.target.value.match( /^\d[\s-.\/]$/ ) !== null ) {
      event.target.value = '0' + event.target.value[0] + '.';
    } else if ( event.target.value.match( /^\d{2}\.\d$/ ) !== null ) {
      let a = event.target.value.split( '.' );
      event.target.value = a[0] + '.0' + a[1];
    } else if ( event.target.value.match( /^\d{2}\.\d{2}$/ ) !== null ) {

      if ( event.target.value.match( /^((0[0-9])|(1[0-9])|(2[0-3]))\.((0\d)|(1\d)|(2\d)|(3\d)|(4\d)|(5\d))$/ ) !== null ) {
      } else {
        event.target.value = moment().hours() + '.' + moment().minutes();
      }
    } else if ( event.target.value.match( /[a-zA-Zа-я\s;]+/gi ) ) {
      event.target.value = event.target.value.replace( /[a-zA-Zа-я;\s]/, '' );
    } else if ( event.target.value.match( /[\s-,/]/ ) ) {
      event.target.value = event.target.value.replace( /[\s-/,]/, '.' );
    } else if ( event.target.value.match( /\.+/ ) ) {
      event.target.value = event.target.value.replace( /\.+/, '.' );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/time.directive.ts